export default "__VITE_ASSET__715ccd68__"